import { t } from "i18next";

export const CheckStatus = (status: number) => {
  switch (status) {
    case 1:
      return (
        <>
          <i className="icon dot-icon my-1 me-2" />
          {t("not_reviewed")}
        </>
      );
    case 2:
      return (
        <>
          <i className="icon tick-icon my-0 me-2" />
          {t("approved_in_the_same_kindergarten")}
        </>
      );
    case 3:
      return (
        <>
          <i className="icon tick-icon my-0 me-2" />
          {t("approved_in_another_kindergarten")}
        </>
      );
    case 4:
      return (
        <>
          <i className="icon close-icon my-0 me-2" />
          {t("rejected")}
        </>
      );

    default:
      return "-";
  }
};

export const CheckStatusNursery = (status: number) => {
  switch (status) {
    case 1:
      return (
        <>
          <i className="icon dot-icon my-1 me-2" />
          {t("not_reviewed")}
        </>
      );
    case 2:
      return (
        <>
          <i className="icon tick-icon my-0 me-2" />
          {t("approved_in_the_same_nursery")}
        </>
      );
    case 3:
      return (
        <>
          <i className="icon tick-icon my-0 me-2" />
          {t("approved_in_another_nursery")}
        </>
      );
    case 4:
      return (
        <>
          <i className="icon close-icon my-0 me-2" />
          {t("rejected")}
        </>
      );

    default:
      return "-";
  }
};


